export const GOOGLE_OAUTH2 = "GOOGLE_OAUTH2";